import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams, useNavigate  } from 'react-router-dom';
import JoditEditor from "jodit-react";
import { ProtectAPi } from '../../../../../api/ProtectAPi';
import { ServerUrl } from '../../../../../api/ServerUrl';
import swal from 'sweetalert';
import BackButton from '../../../../tools/BackButton';

const RdEdit = () => {
    const { http } = ProtectAPi();
    const editor = useRef(null);
    const { id } = useParams();
    const [loader, setLoader] = useState('off');
    const navigate = useNavigate();
    const [layoutTitle, setLayoutTitle] = useState('');
    const [slug, setSlug] = useState('');
    const [layoutDescription, setLayoutDescription] = useState('');
    const [youtubeUrl, setyoutubeUrl] = useState('');
    const [layoutImage, setLayoutImage] = useState(null);
    const [altText, setAltText] = useState('');

    const [layoutImageError, setLayoutImageError] = useState('');
    const [imagePreview, setImagePreview] = useState('');
    const [titleError, setTitleError] = useState('');
    const [slugError, setSlugError] = useState('');
    const [descriptionError, setDescriptionError] = useState('');
    const [youtubeUrlError, setYoutubeUrlError] = useState('');
    const [altTextError, setAltTextError] = useState('');

    const httpCPage = ServerUrl;

    useEffect(() => {
        http.get(`/get-single-rd/${id}`)
            .then(res => {
                setLayoutTitle(res.data.title);
                setSlug(res.data.slug || '');
                setLayoutDescription(res.data.description);
                setyoutubeUrl(res.data.url);
                setAltText(res.data.alt || '');

                const layoutImage = res.data.image;
                if (layoutImage) {
                    const layoutImageShow = `${httpCPage}/backend/img/rd/${layoutImage}`;
                    setImagePreview(layoutImageShow);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, [id]);

const submitForm = () => {
    setLoader('on');
    setLayoutImageError('');
    setTitleError('');
    setSlugError('');
    setDescriptionError('');
    setAltTextError('');
    setYoutubeUrlError('');

    const formData = new FormData();
    formData.append('title', layoutTitle);
    formData.append('slug', slug);
    formData.append('description', layoutDescription);
    formData.append('alt', altText);
    formData.append('url', youtubeUrl);

    if (layoutImage) {
        formData.append('image', layoutImage);
    }

    http.post(`/update-rd/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }).then(res => {
        if (res.data.status === '422') {
            const errors = res.data.error;
            setLoader('off');
            setLayoutImageError(errors.image?.[0] || '');
            setTitleError(errors.title?.[0] || '');
            setSlugError(errors.slug?.[0] || '');
            setDescriptionError(errors.description?.[0] || '');
            setAltTextError(errors.alt?.[0] || '');
            setYoutubeUrlError(errors.url?.[0] || '');
        } else {
            setLoader('off');
            swal('Success', res.data.msg, 'success');
            navigate('/admin/pages/research-development');
        }
    }).catch(error => {
        setLoader('off');
        console.error('Error:', error);
    });
};

    const handleImageChange = (e) => {
        const selectedImage = e.target.files[0];
        setLayoutImage(selectedImage);
        const previewURL = URL.createObjectURL(selectedImage);
        setImagePreview(previewURL);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'layoutTitle') {
            setLayoutTitle(value);
        } else if (name === 'slug') {
            setSlug(value);
        } else if (name === 'youtubeUrl') {
            setyoutubeUrl(value);
        } else if (name === 'altText') {
            setAltText(value);
        }
    };

    const editorConfig = useMemo(() => ({
        readonly: false,
        placeholder: 'Start typing...',
        uploader: {
            insertImageAsBase64URI: true
        }
    }), []);

    return (
        <div className="main-content">
            <section className="section">
                <div className="section-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="card card-primary">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between">
                                        <h5>Edit Research & Development</h5>
                                        <BackButton />
                                    </div>

                                    <div className="row mt-3">
                                        {/* Image Upload */}
                                        <div className="col-md-4">
                                            <label>Research Image</label>
                                            <div className="logo-box">
                                                <label htmlFor="layoutImage">
                                                    <div className="image-box border dottet p-2 rounded">
                                                        {imagePreview ? (
                                                            <img src={imagePreview} className="img-fluid" alt="Preview" />
                                                        ) : (
                                                            <img src="https://w7.pngwing.com/pngs/159/705/png-transparent-computer-computer-trademark-computer-logo.png" className="img-fluid" alt="Default" />
                                                        )}
                                                    </div>
                                                    <input type="file" id="layoutImage" className="form-control d-none" onChange={handleImageChange} />
                                                    <span className="btn btn-primary mt-1 w-100">Change Research Image</span>
                                                    <span className="text-danger">{layoutImageError}</span>
                                                </label>
                                            </div>
                                        </div>

                                        {/* Alt Text */}
                                        <div className="col-md-12 mt-3">
                                            <label>Image Alt Text</label>
                                            <input
                                                type="text"
                                                name="altText"
                                                className="form-control"
                                                placeholder="Enter alt text"
                                                value={altText}
                                                onChange={handleInputChange}
                                            />
                                            <span className="text-danger">{altTextError}</span>
                                        </div>

                                        {/* Title */}
                                        <div className="col-md-12 mt-3">
                                            <label>Research Title</label>
                                            <input
                                                type="text"
                                                name="layoutTitle"
                                                className="form-control"
                                                placeholder="Enter research title"
                                                value={layoutTitle}
                                                onChange={handleInputChange}
                                            />
                                            <span className="text-danger">{titleError}</span>
                                        </div>

                                        {/* Slug */}
                                        <div className="col-md-12 mt-3">
                                            <label>Slug (Optional)</label>
                                            <input
                                                type="text"
                                                name="slug"
                                                className="form-control"
                                                placeholder="Enter SEO-friendly slug"
                                                value={slug}
                                                onChange={handleInputChange}
                                            />
                                            <span className="text-danger">{slugError}</span>
                                        </div>

                                        {/* YouTube URL */}
                                        <div className="col-md-12 mt-3">
                                            <label>YouTube Video URL</label>
                                            <input
                                                type="url"
                                                name="youtubeUrl"
                                                className="form-control"
                                                placeholder="Paste YouTube video URL"
                                                value={youtubeUrl}
                                                onChange={handleInputChange}
                                            />
                                            <span className="text-danger">{youtubeUrlError}</span>
                                        </div>

                                        {/* Description */}
                                        <div className="col-md-12 mt-4">
                                            <label>Description</label>
                                            <JoditEditor
                                                ref={editor}
                                                value={layoutDescription}
                                                config={{
                                                    readonly: false,
                                                    height: 400,
                                                    placeholder: 'Start typing...',
                                                    uploader: {
                                                        insertImageAsBase64URI: true
                                                    }
                                                }}
                                                tabIndex={1}
                                                onBlur={newContent => setLayoutDescription(newContent)}
                                                onChange={() => {}}
                                            />
                                            <span className="text-danger">{descriptionError}</span>
                                        </div>

                                        {/* Submit */}
                                        <div className="col-md-12 mt-5 mb-4">
                                            {loader === 'off' ? (
                                                <button type="submit" onClick={submitForm} className="btn btn-lg btn-primary">Update</button>
                                            ) : (
                                                <div className="spinner-border text-dark" role="status"></div>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default RdEdit;
